import React from 'react'
import {createSelector} from 'reselect'
import {generatePath} from '@modifi/router'
import {formatNumber} from '@modifi/plugin-i18n'
import {TradePartnerApprovalStatus} from '@modifi/enums'

import {
  ExtendedOnboardingTradePartnerView,
  selectSellerTradePartners,
} from '../../../../../data/seller-trade-partners'
import {ROUTE_INTRO} from '../../../../../routes/constants'
import StatusTag from '../../../../seller-trade-partners/seller-trade-partner-summary/selector'

export const getBuyerLimitForTable = (
  tradePartner: ExtendedOnboardingTradePartnerView
): number | string => {
  const currency = tradePartner?.allocatedLimit?.currency
  const amount = tradePartner?.allocatedLimit?.amount

  return amount && currency && parseInt(amount as unknown as string, 10)
    ? formatNumber(amount, {
        currency,
        trimDecimals: true,
      })
    : '-'
}

/** One row of the pre-underwriting buyer list table. */
export type BuyerSummaryEntry = {
  route: string
  externalBuyerId?: string
  name: string
  buyerLimit: string | number
  status: React.ReactNode
}

export const selectBuyerSummaryData = createSelector(selectSellerTradePartners, tradePartners => {
  const summaryData = tradePartners.map(tradePartner => ({
    route: generatePath(ROUTE_INTRO),
    externalBuyerId: tradePartner?.tradePartnerCompany?.externalCompanyId,
    name: tradePartner?.tradePartnerCompany?.address?.companyName || '',
    buyerLimit: getBuyerLimitForTable(tradePartner),
    status: tradePartner?.tradePartnerApproval?.status ? (
      <StatusTag
        status={tradePartner?.tradePartnerApproval?.status as TradePartnerApprovalStatus}
      />
    ) : (
      ''
    ),
  }))
  return summaryData
})
